module.exports = __webpack_public_path__ + "media/files/sample_agency_check_file-f125e785438d2f306abc16337d5c1b60.csv";